exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#active {\n  color: #2E8B57;\n  padding-top: 8px; }\n\n#deactive {\n  padding-top: 8px;\n  color: #FF4500; }\n\n#delete {\n  color: #006400; }\n\n#addUserSeeding {\n  background-color: red; }\n\n.custom-process-txt-file {\n  direction: rtl; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/fb-user-seeding/fb-user-seeding.component.scss
// module id = ../../../../../src/app/views/fb-user-seeding/fb-user-seeding.component.scss
// module chunks = main